<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelCheck()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button *ngIf="documentTemp.customer.id && documentTemp.site.id" (click)="scanItem()">
                <ion-icon slot="icon-only" name="barcode"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Check Ward</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <customer [document]="documentTemp" (customerChange)="listenCustomer($event)"></customer>
    <site [document]="documentTemp"></site>
<!--    <ion-button color="light" expand="full" shape="round" *ngIf="documentTemp.customer.id && documentTemp.site.id"-->
<!--                (click)="scanItem()">-->
<!--        Scan-->
<!--        <ion-icon slot="end" name="barcode"></ion-icon>-->
<!--    </ion-button>-->

    <ion-item *ngIf="documentTemp.site && documentTemp.site.id">
        <ion-input [(ngModel)]="manualInput" placeholder="Manual barcode input"></ion-input>
        <ion-button slot="end" (click)="handleScanResult(manualInput)" [disabled]="!manualInput" color="light">
            <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
    </ion-item>
</ion-content>
